module.exports = "/legacy/1472e222c9ed7a2a0cb42f46ae6c485b.svg";